import { Reveal } from "@/components/Reveal";
import { PageHeader } from "@/pages/Services";
import { useCollection } from "@/hooks/useCollection";
import { Star } from "lucide-react";

export default function Clients() {
  const { items } = useCollection("testimonials");
  return (
    <div>
      <PageHeader eyebrow="Klien Kami" title="Dipercaya oleh Klien Kami" subtitle="Kepuasan klien adalah bukti komitmen kami terhadap kualitas dan pelayanan." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 sm:py-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <Reveal key={t.id} delay={i * 0.07}>
              <div className="bg-ll-card rounded-2xl p-7 gold-border h-full flex flex-col" data-testid={`testimonial-card-${i}`}>
                <div className="flex gap-1 mb-4">{Array.from({ length: t.rating || 5 }).map((_, k) => <Star key={k} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" />)}</div>
                <p className="text-white/80 italic flex-1">"{t.quote}"</p>
                <div className="mt-5 flex items-center gap-3">
                  <div className="w-11 h-11 rounded-full btn-gold flex items-center justify-center font-bold">{t.name?.[0]}</div>
                  <div><div className="text-white font-semibold text-sm">{t.name}</div><div className="text-white/50 text-xs">{t.role} · {t.company}</div></div>
                </div>
              </div>
            </Reveal>
          ))}
          {items.length === 0 && <p className="text-white/50">Belum ada testimoni.</p>}
        </div>
      </section>
    </div>
  );
}
